import { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "platzwart.theme";
const VALID = ["dark-industrial", "light-corporate"];

const ThemeContext = createContext(null);

function applyTheme(theme) {
    const root = document.documentElement;
    VALID.forEach((t) => root.classList.remove(t));
    root.classList.add(theme);
    root.dataset.theme = theme;
    // Tailwind's `dark:` utility uses the `.dark` class -- keep it in sync too.
    if (theme === "dark-industrial") root.classList.add("dark");
    else root.classList.remove("dark");
}

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "dark-industrial";
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return VALID.includes(stored) ? stored : "dark-industrial";
    });

    useEffect(() => {
        applyTheme(theme);
        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            /* ignore */
        }
    }, [theme]);

    const toggle = useCallback(() => {
        setTheme((t) => (t === "dark-industrial" ? "light-corporate" : "dark-industrial"));
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
    return ctx;
}
